import { Component, EventEmitter, Input, Optional, Output } from '@angular/core';
import { Router, RouterLink } from '@angular/router';

import { RtAnalyticsModule } from '@recruitee/analytics';
import { FollowButtonComponent } from '@recruitee/candidate-ui';
import { JobsAnalytics } from '@recruitee/offers';
import type { OfferItem } from '@recruitee/offers-types';
import { OfferKind, OfferStatus } from '@recruitee/offers-types';
import { GroupComponent, IconButtonComponent } from '@recruitee/user-interface';

import { ActionsDropdownContainerComponent } from '../../../containers/actions-dropdown-container.component';

@Component({
  selector: 'rt-offer-table-row-actions',
  styleUrls: ['./offer-table-row-actions.component.less'],
  templateUrl: './offer-table-row-actions.component.html',
  imports: [
    GroupComponent,
    IconButtonComponent,
    RtAnalyticsModule,
    ActionsDropdownContainerComponent,
    FollowButtonComponent,
    RouterLink,
  ],
})
export class OfferTableRowActionsComponent {
  @Input() public offer: OfferItem;
  @Input() public followLoading: boolean;
  @Input() public canPromoteSection: boolean;
  @Input() public canManageJobs: boolean;

  @Output() public toggleFollow: EventEmitter<OfferItem> = new EventEmitter();
  @Output() public editClick = new EventEmitter<void>();

  constructor(
    private router: Router,
    @Optional() private jobsAnalytics: JobsAnalytics,
  ) {}

  public get hasPromote(): boolean {
    return (
      this.canPromoteSection &&
      this.offer.kind === OfferKind.Job &&
      (this.offer.status === OfferStatus.Published || this.offer.status === OfferStatus.Internal)
    );
  }

  public get hasEdit(): boolean {
    return this.canManageJobs && this.offer.status !== OfferStatus.Archived;
  }

  public editOffer() {
    if (this.offer.kind === OfferKind.Job) {
      const status = this.offer.status === OfferStatus.Published ? 'public' : this.offer.status;
      if (this.jobsAnalytics?.trackEdit) this.jobsAnalytics.trackEdit(status);
    }

    const redirect =
      this.offer.kind === OfferKind.Job
        ? `/offers/${this.offer.slug}/edit`
        : `/talent_pools/${this.offer.slug}/edit`;

    this.router.navigate([redirect]);
  }
}
